import Joi from 'joi';

import { regexp } from '../../data/regexp';
import { UserTypeEnum } from '../../types/enums';

export const getUsersScheme = Joi.object({
  userGroup: Joi.string()
    .valid(...Object.values(UserTypeEnum))
    .label('User Group')
    .messages({ 'any.only': '{{#label}} is invalid' }),
});

export const userScheme = Joi.object({
  id: Joi.string().required().label('User ID').messages({
    'any.required': '{{#label}} is required',
    'string.empty': '{{#label}} is required',
  }),
});

export const createUserScheme = Joi.object({
  fullName: Joi.string()
    .required()
    .pattern(regexp.fullName)
    .label('User Name')
    .messages({
      'string.pattern.base': '{{#label}} is invalid',
    }),
  userType: Joi.string()
    .required()
    .valid(...Object.values(UserTypeEnum))
    .label('User Type')
    .messages({
      'any.only': '{{#label}} is invalid',
    }),
  temporaryPassword: Joi.string().required().label('Password'),
  email: Joi.string().pattern(regexp.email).label('Email').messages({
    'string.pattern.base': '{{#label}} is required',
  }),
});

export const updateUserScheme = Joi.object({
  id: Joi.string().required().label('User ID').messages({
    'any.required': '{{#label}} is required',
    'string.empty': '{{#label}} is required',
  }),
  name: Joi.string()
    .required()
    .pattern(regexp.fullName)
    .label('User Name')
    .messages({
      'string.pattern.base': '{{#label}} is invalid',
    }),
});

export const checkEmailScheme = Joi.object({
  email: Joi.string().required().pattern(regexp.email).label('Email').messages({
    'string.pattern.base': '{{#label}} is invalid',
  }),
});
